module.exports = __webpack_public_path__ + "img/print_fingerprint.3d0c0c9.jpg";